import React, { useEffect, useState, useRef, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router";
import { LoadingScreen } from "../../../UiComponents/LoadingComponent";
import {UpdateorCancelButtons} from "./UpdateorCancelButtons";
import { UrlPath } from "../../../../config/routeConfig";
import { useLocation } from "react-router-dom";
import { insertOrUpdateContactAddresses } from "../../../../config/apiConfig";
import { sbaAxios } from "../../../utils/sbaAxios";
import { SBNotify } from "../../../utils/sbNotify";
import { ToastContainer } from "react-toastify";
import { SBADropDown } from "../../../UiComponents/SBADropDown";
import { getCommonCountries } from "../../../actions/CommonAction";

export const AddressesEdit = () => {

  const dispatch = useDispatch();
  const history = useNavigate();
  const locationData = useLocation();
  const GState=useSelector(state=>state);
  const countryDS=GState.common.country;
  const stateDS=GState.common.state;

  const contactDetails = locationData.state.AddressData;

  const [loading, setLoading] = useState(true);
  const [state, setState] = useState({ StateName: contactDetails.homeState, StateId: 0 });
  const [homeCountry, setHomeCountry] = useState({ CountryName: contactDetails.homeCountry, CountryId: contactDetails.homeCountryId });
  const [businessCountry, setBusinessCountry] = useState({ CountryName: contactDetails.businessCountry, CountryId: contactDetails.businessCountryId});
  const [stateCountry, setStateCountry] = useState({ CountryName: contactDetails.statementAddressCountry, CountryId: contactDetails.statementAddressCountryId});

  const queryParams = new URLSearchParams(locationData.search);
  const paramValue = queryParams.get('ContactTypeId'); 


    useEffect(() => {
    document.title = `Investor Details`;
    dispatch(getCommonCountries())
  }, []);

  useEffect(() => {
    contactDetails && setLoading(false);
    setState({StateName:contactDetails.homeState,StateId:0});
  }, [contactDetails]);

  const redirectLinkClick = () => {
    history(`${UrlPath.InvestorDetails}${contactDetails.contactId}?ContactTypeId=${paramValue}`, { state: { ActiveContactInfoButton: 2 } });
  };
  const updatedState=(e)=>{

  };
  const updatedCountry=(e)=>{

  };

  const [addressesState, setAddressesState] = useState({
    homeNote: contactDetails.homeNote || "",
    homeCity: contactDetails.homeCity || "",
    homeState: contactDetails.homeState || "",
    homeZip: contactDetails.homeZip || "",
    homeProvince: contactDetails.homeProvince || "",
    homeCountry: contactDetails.homeCountry || "",
    homeCountryId: contactDetails.homeCountryId || "",
    homePhone: contactDetails.homePhone  || "",
    homeIsInvoicingAddress: contactDetails.homeUseforInvoicing || "",
    homeAddressStreet1: contactDetails.homeAddressStreet1 || "",
    homeAddressStreet2: contactDetails.homeAddressStreet2 || "",
    businessNote: contactDetails.businessNote || "",
    businessCity: contactDetails.businessCity || "",
    businessState: contactDetails.businessState || "",
    businessZip: contactDetails.businessZip || "",
    businessProvince: contactDetails.businessProvince || "",
    businessCountry: contactDetails.businessCountry || "",
    businessCountryId: contactDetails.businessCountryId ||"",
    businessAddressStreet1: contactDetails.businessAddressStreet1 || "",
    businessAddressStreet2: contactDetails.businessAddressStreet2 || "",
    businessIsInvoicingAddress: contactDetails.businessUseforInvoicing || "",
    statementNote: contactDetails.statementNote || "",
    statementAddressCity: contactDetails.statementAddressCity || "",
    statementAddressState: contactDetails.statementAddressState || "",
    statementAddressZip: contactDetails.statementAddressZip || "",
    statementAddressProvince: contactDetails.statementAddressProvince || "",
    statementAddressCountry: contactDetails.statementAddressCountry || "",
    statementAddressCountryId: contactDetails.statementAddressCountryId || "",
    statementAddressStreet1: contactDetails.statementAddressStreet1 || "",
    statementAddressStreet2: contactDetails.statementAddressStreet2 || "",
    statementIsInvoicingAddress: contactDetails.statementUseforInvoicing || "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setAddressesState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleCheckbox = (e) => {
    const { name, checked } = e.target;
    const checkboxNames = ['homeIsInvoicingAddress', 'businessIsInvoicingAddress', 'statementIsInvoicingAddress'];
  
    let updatedState = { ...addressesState };
  
    checkboxNames.forEach((checkboxName) => {
      updatedState[checkboxName] = checkboxName === name ? checked : false;
    });
  
    setAddressesState(updatedState);
  };
  
  const contactAddresses = [];

  const fieldsToInclude = [
    "Home",
    "Business",
    "Statement",    
  ];
  
  for (const field of fieldsToInclude) {
    let contactAddressId;
    let contactAddressTypeId;
    let addressName;
    let addressStreet;
    let addressStreet2;
    let addressCity;
    let addressState;
    let addressZip;
    let addressProvince;
    let addressCountry;
    let isInvoicingAddress;
    let addressCountrycode;
    let note;
  
      switch (field) {
        case "Home":
          contactAddressId= contactDetails.homeAddressId;
          contactAddressTypeId= contactDetails.homeAddressTypeId;
          addressName= "string";
          addressStreet= addressesState.homeAddressStreet1;
          addressStreet2= addressesState.homeAddressStreet2;
          addressCity= addressesState.homeCity;
          addressState= addressesState.homeState;
          addressZip= addressesState.homeZip;
          addressProvince= addressesState.homeProvince;
          addressCountry = addressesState.homeCountry;
          addressCountrycode = addressesState.homeCountryId;
          isInvoicingAddress= addressesState.homeIsInvoicingAddress;
          note= addressesState.homeNote;
          break;
        case "Business":
          contactAddressId= contactDetails.businessAddressId;
          contactAddressTypeId= contactDetails.businessAddressTypeId;
          addressName= "string";
          addressStreet= addressesState.businessAddressStreet1;
          addressStreet2= addressesState.businessAddressStreet2;
          addressCity= addressesState.businessCity;
          addressState= addressesState.businessState;
          addressZip= addressesState.businessZip;
          addressProvince= addressesState.businessProvince;
          addressCountry = addressesState.businessCountry;
          addressCountrycode = addressesState.businessCountryId;
          isInvoicingAddress= addressesState.businessIsInvoicingAddress;
          note= addressesState.businessNote;
          break;
        case "Statement":
          contactAddressId= contactDetails.statementAddressId;
          contactAddressTypeId= contactDetails.statementAddressTypeId;
          addressName= "string";
          addressStreet= addressesState.statementAddressStreet1;
          addressStreet2= addressesState.statementAddressStreet2;
          addressCity= addressesState.statementAddressCity;
          addressState= addressesState.statementAddressState;
          addressZip= addressesState.statementAddressZip;
          addressProvince= addressesState.statementAddressProvince;
          addressCountry = addressesState.statementAddressCountry;
          addressCountrycode = addressesState.statementAddressCountryId;
          isInvoicingAddress= addressesState.statementIsInvoicingAddress;
          note= addressesState.statementNote;
          break;       
      }
  
      const contactAddressesType = {
        contactAddressId: contactAddressId,
        contactId: contactDetails.contactId,
        contactAddressTypeId: contactAddressTypeId,
        addressName: addressName,
        addressStreet: addressStreet,
        addressStreet2: addressStreet2,
        addressCity: addressCity,
        addressState: addressState,
        addressZip:addressZip,
        addressProvince: addressProvince,
        addressCountry: addressCountry,
        addressCountryId : addressCountrycode,
        isInvoicingAddress: isInvoicingAddress === true ? 1 : 0,
        note: note,
        modifiedBy: 0,
      };
  
      contactAddresses.push(contactAddressesType);
  }

  const handleSave = async () => {

    let saveSuccess = true;    

  if (saveSuccess) {
    const response = await sbaAxios({
      url: `${insertOrUpdateContactAddresses}`,
      method: "post",
      data: contactAddresses,
    });
    if (response > 0) {
      SBNotify({ type: "success", Msg: "Updated Successfully" });
      redirectLinkClick();
    }
      else {
        SBNotify({ type: "warning", Msg: "Failed" });
      }
    }  

  };

  return (
    <>
      {loading ? (
        <>
          <LoadingScreen />
        </>
      ) : (
        <>
          <div id="contacts" className="mainContentData">
            <div className="bg-white m-3 p-border rounded">
              <div className="bg-white p-4">
                <div className="content-container">
                  <div className="col-lg-12 px-0">
                    <div className="row m-0">
                      <div className="col-md-3">
                        <div className="mb-4">
                          <span className="fw-medium custom-font-size">
                            Home Address
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-12 px-0">
                    <div className="row m-0 gap-5">
                      <div className="col-md-2">
                        <div className="mb-4">
                          <span className="fw-medium">Address 1</span>
                          <input
                            className="form-control w-75"
                            type="text"
                            name="homeAddressStreet1"
                            Value={addressesState.homeAddressStreet1}
                            onChange={handleChange}
                          />
                        </div>
                        <div className="mb-4">
                          <span className="fw-medium">Province</span>
                          <input
                            className="form-control w-75"
                            type="text"
                            name="homeProvince"
                            Value={addressesState.homeProvince}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div className="mb-4">
                          <span className="fw-medium">Address 2</span>
                          <input
                            className="form-control w-75"
                            type="text"
                            name="homeAddressStreet2"
                            Value={addressesState.homeAddressStreet2}
                            onChange={handleChange}
                          />
                        </div>
                        <div className="mb-4">
                          <span className="fw-medium d-block">Country</span>
                          <SBADropDown data={countryDS} value={homeCountry} onChange={(e) => {
                              setHomeCountry(e.value); setAddressesState((prevState) => ({
                                ...prevState,
                                  homeCountry: e.value.CountryName,
                                  homeCountryId: e.value.CountryId,
                              }))
                            }} textField={"CountryName"} valueField={"CountryId"}  className="w-75"/>
                          {/* <input
                            className="form-control w-75"
                            type="text"
                            name="homeCountry"
                            Value={addressesState.homeCountry}
                            onChange={handleChange}
                          /> */}
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div className="mb-4">
                          <span className="fw-medium">City</span>
                          <input
                            className="form-control w-75"
                            type="text"
                            name="homeCity"
                            Value={addressesState.homeCity}
                            onChange={handleChange}
                          />
                        </div>
                        <div className="mb-4">
                          <span className="fw-medium">Notes</span>
                          <input
                            className="form-control w-75"
                            type="text"
                            name="homeNote"
                            Value={addressesState.homeNote}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div className="mb-4">
                          <span className="fw-medium">State</span>
                          {/* <SBADropDown data={stateDS}  value={state} onChange={updatedState} textField={"StateName"} valueField={"StateId"} /> */}
                          <input
                            className="form-control w-75"
                            type="text"
                            name="homeState"
                            Value={addressesState.homeState}
                            onChange={handleChange}
                          />
                        </div>
                        <div className="mb-4">
                          <div className="mb-2">
                            <span className="fw-medium">Use for Invoicing</span>
                          </div>
                          <input
                            className="m-0"
                            type="checkbox"
                            name="homeIsInvoicingAddress"
                            checked={
                              addressesState.homeIsInvoicingAddress === true
                            }
                            onChange={handleCheckbox}
                          />
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div className="mb-4">
                          <span className="fw-medium">Zip</span>
                          <input
                            className="form-control w-75"
                            type="text"
                            name="homeZip"
                            Value={addressesState.homeZip}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr />
                  <div className="col-lg-12 px-0">
                    <div className="row m-0">
                      <div className="col-md-3">
                        <div className="mb-4">
                          <span className="fw-medium custom-font-size">
                            Business Address
                          </span>
                          <p className="fw-medium mb-0"></p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-12 px-0">
                    <div className="row m-0 gap-5">
                      <div className="col-md-2">
                        <div className="mb-4">
                          <span className="fw-medium">Address 1</span>
                          <input
                            className="form-control w-75"
                            type="text"
                            name="businessAddressStreet1"
                            Value={addressesState.businessAddressStreet1}
                            onChange={handleChange}
                          />
                        </div>
                        <div className="mb-4">
                          <span className="fw-medium">Province</span>
                          <input
                            className="form-control w-75"
                            type="text"
                            name="businessProvince"
                            Value={addressesState.businessProvince}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div className="mb-4">
                          <span className="fw-medium">Address 2</span>
                          <input
                            className="form-control w-75"
                            type="text"
                            name="businessAddressStreet2"
                            Value={addressesState.businessAddressStreet2}
                            onChange={handleChange}
                          />
                        </div>
                        <div className="mb-4">
                          <span className="fw-medium d-block">Country</span>
                            <SBADropDown data={countryDS} value={businessCountry} onChange={(e) => {
                              setBusinessCountry(e.value); setAddressesState((prevState) => ({
                                ...prevState,
                                  businessCountry: e.value.CountryName,
                                  businessCountryId: e.value.CountryId,
                              }))
                            }} textField={"CountryName"} valueField={"CountryId"} className="w-75" />
                          {/* <input
                            className="form-control w-75"
                            type="text"
                            name="businessCountry"
                            Value={addressesState.businessCountry}
                            onChange={handleChange}
                          /> */}
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div className="mb-4">
                          <span className="fw-medium">City</span>
                          <input
                            className="form-control w-75"
                            type="text"
                            name="businessCity"
                            Value={addressesState.businessCity}
                            onChange={handleChange}
                          />
                        </div>
                        <div className="mb-4">
                          <span className="fw-medium">Notes</span>
                          <input
                            className="form-control w-75"
                            type="text"
                            name="businessNote"
                            Value={addressesState.businessNote}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div className="mb-4">
                          <span className="fw-medium">State</span>
                          <input
                            className="form-control w-75"
                            type="text"
                            name="businessState"
                            Value={addressesState.businessState}
                            onChange={handleChange}
                          />
                        </div>
                        <div className="mb-4">
                          <div className="mb-2">
                            <span className="fw-medium">Use for Invoicing</span>
                          </div>
                          <input
                            type="checkbox"
                            name="businessIsInvoicingAddress"
                            checked={
                              addressesState.businessIsInvoicingAddress === true
                            }
                            onChange={handleCheckbox}
                          />
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div className="mb-4">
                          <span className="fw-medium">Zip</span>
                          <input
                            className="form-control w-75"
                            type="text"
                            name="businessZip"
                            Value={addressesState.businessZip}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr />
                  <div className="col-lg-12 px-0">
                    <div className="row m-0">
                      <div className="col-md-3">
                        <div className="mb-4">
                          <span className="fw-medium custom-font-size">
                            Statement Address
                          </span>
                          <p className="fw-medium mb-0"></p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-12 px-0">
                    <div className="row m-0 gap-5">
                      <div className="col-md-2">
                        <div className="mb-4">
                          <span className="fw-medium">Address 1</span>
                          <input
                            className="form-control w-75"
                            type="text"
                            name="statementAddressStreet1"
                            Value={addressesState.statementAddressStreet1}
                            onChange={handleChange}
                          />
                        </div>
                        <div className="mb-4">
                          <span className="fw-medium">Province</span>
                          <input
                            className="form-control w-75"
                            type="text"
                            name="statementAddressProvince"
                            Value={addressesState.statementAddressProvince}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div className="mb-4">
                          <span className="fw-medium">Address 2</span>
                          <input
                            className="form-control w-75"
                            type="text"
                            name="statementAddressStreet2"
                            Value={addressesState.statementAddressStreet2}
                            onChange={handleChange}
                          />
                        </div>
                        <div className="mb-4">
                          <span className="fw-medium d-block">Country</span>
                          <SBADropDown data={countryDS} value={stateCountry} onChange={(e) => {
                              setStateCountry(e.value); setAddressesState((prevState) => ({
                                ...prevState,
                                  statementAddressCountry: e.value.CountryName,
                                  statementAddressCountryId: e.value.CountryId
                              }))
                            }} textField={"CountryName"} valueField={"CountryId"} className="w-75" />
                          {/* <input
                            className="form-control w-75"
                            type="text"
                            name="statementAddressCountry"
                            Value={addressesState.statementAddressCountry}
                            onChange={handleChange}
                          /> */}
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div className="mb-4">
                          <span className="fw-medium">City</span>
                          <input
                            className="form-control w-75"
                            type="text"
                            name="statementAddressCity"
                            Value={addressesState.statementAddressCity}
                            onChange={handleChange}
                          />
                        </div>
                        <div className="mb-4">
                          <span className="fw-medium">Notes</span>
                          <input
                            className="form-control w-75"
                            type="text"
                            name="statementNote"
                            Value={addressesState.statementNote}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div className="mb-4">
                          <span className="fw-medium">State</span>
                          <input
                            className="form-control w-75"
                            type="text"
                            name="statementAddressState"
                            Value={addressesState.statementAddressState}
                            onChange={handleChange}
                          />
                        </div>
                        <div className="mb-4">
                          <div className="mb-2">
                            <span className="fw-medium">Use for Invoicing</span>
                          </div>
                          <input
                            className="m-0"
                            type="checkbox"
                            name="statementIsInvoicingAddress"
                            checked={
                              addressesState.statementIsInvoicingAddress ===
                              true
                            }
                            onChange={handleCheckbox}
                          />
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div className="mb-4">
                          <span className="fw-medium">Zip</span>
                          <input
                            className="form-control w-75"
                            type="text"
                            name="statementAddressZip"
                            Value={addressesState.statementAddressZip}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-12 px-0">
              <UpdateorCancelButtons
                onSave={handleSave}
                onCancel={redirectLinkClick}
              />
            </div>
          </div>
        </>
      )}
      <ToastContainer/>
    </>
  );
};
